import React, {Component} from 'react'
import { connect } from 'react-redux';
import {addArticleCategory} from '../../../redux/_actions/articles/category/index'

// React Notification
import { NotificationManager } from 'react-notifications';

// reactstrap components
import { 
    FormGroup,
    Card,
    CardHeader,
    Form,
    Label,
    Input,
    Button,
    Container,
    Row,
    Col
  } from "reactstrap";
  // core components
  import Header from "components/Headers/Header.js";

  export class addCategory extends Component {
    state = {
      title: '',
      description: '',
      errors: {}
    };

    onChangeInput = (e) => this.setState({
      [e.target.name] : e.target.value
    })
  
    handleSubmit = (e) =>{
      e.preventDefault();
      
      const { title, description } = this.state;
  
      //Check for errors
      if(title === ''){
        this.setState({ errors: { title: 'link is required'}});
        return;
      }
      if (description === '') {
        this.setState({ errors: { description: 'description image is required'} });
      }
      const newPropertySponsor = {
        title,
        description
      }
     
      
      //Submit Category
      this.props.addArticleCategory(newPropertySponsor)
      NotificationManager.success('Article category added!', 'Successful!', 2000);
      
       //Clear state
       this.setState({
        title: '',
        description: '',
        errors: {}
      })
      this.props.history.push('/admin/article/categories');
      
    }

    render() {
      const { title, description, errors } = this.state;

    return (
        <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Create Article Category</h3>
                </CardHeader>
                <Form onSubmit={this.handleSubmit} >
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="Name">Name</Label>
                      <Input type="text" value={title} onChange = {this.onChangeInput} name="title" error={errors.name} id="Name" />
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="description">description</Label>
                      <Input type="text" value={description} onChange={this.onChangeInput} error={errors.description} name="description" id="description" />
                    </Col>
                  </FormGroup>
                  
                  <Button onClick={this.handleSubmit} className="btn btn-primary mr-2">Submit</Button>
                </Form>
              </Card>
            </div>
          </Row>
         
        </Container>
      </>
        )
      }
    }
 export default connect(null, {addArticleCategory})(addCategory);

